export default "__VITE_ASSET__DFldFt3o__"